<template>
  <v-row no-gutters>
    <!--  -->
    <v-container>
      <v-img height="280" style="background-color: #3742c0;" class="rounded-lg"  :src="'/images/fit-uii-hero.jpeg'">
        <v-container>
          <div class="text-h4 font-weight-bold pt-0 mt-6 pl-5 mt-0 mb-6 white--text">
            {{ $t('faculty') }} <span class="yellow--text text--darken-2">{{ $t('app_name') }}</span>
          </div>
          <div class="text-body-1 pt-0 mt-0 pl-5 mt-0 mb-6 white--text">
            {{ $t('app_description') }}
          </div>
          <div v-if="user">
            <div v-if="role.includes(4)">
              <v-btn  class="m-3 rounded-pill" color="white darken-4 " :to="{ name: 'home' }" >Menu Kerja
                praktik</v-btn>
            </div>
            <div v-else-if="role.includes(2)">
              <ul>
                <li><v-badge color="red" :content="messagesVerification" :value="messagesVerification" xs overlap><v-btn
                      small class="mb-3" :to="{ name: 'verify-officer' }">Verifikasi Pendaftaran</v-btn></v-badge></li>
                <li><v-badge color="red" :content="messagesValidation" :value="messagesValidation" xs overlap><v-btn small
                      class="mb-3" :to="{ name: 'validate-officer' }">Verifikasi Surat Balasan</v-btn></v-badge></li>
              </ul>
            </div>
            <div v-else-if="role.includes(3)">
              <v-btn  class="m-3 rounded-pill" color="white darken-4 " :to="{ name: 'home-lecturer' }" >Menu Mahasiswa Bimbingan</v-btn>
            </div>
          </div>
        </v-container>
      </v-img>
    </v-container>

    <v-container class="p-4 mt-5">
      <v-row class="d-flex rounded" style="background-color: #f3f6f9;">
        <v-col cols="12" md="5" class="d-flex align-center p-5">
          <div>
            <h3 class="indigo--text text--darken-4">Sistem informasi <br> <span class="font-weight-bold ">Kerja
                praktik</span></h3>
            <p>SIM KP atau Sistem informasi kerja praktik merupakan sistem yang digunakan untuk menunjang kegiatan kerja
              praktik mahasiswa. Berikut alur pada SIM KP. </p>
          </div>
          <v-divider vertical></v-divider>
        </v-col>

        <v-col cols="12" md="7">
          <v-row class="p-3">
            <v-col cols="12" md="6">
              <div class="text-center">
                <v-avatar class="mb-2" size="40" color="indigo lighten-5">
                  <v-icon color="red darken-1">mdi-file-edit</v-icon>
                </v-avatar>
                <h6 class="font-weight-bold indigo--text text--darken-4">1. Pendaftaran KP</h6>
                <p class="text-caption pb-0">Mahasiswa melakukan pendaftaran KP pada menu Kerja praktik. Setelah melakukan
                  pendaftaran, silakan tunggu petugas untuk memverifikasi pendaftaran.</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-center">
                <v-avatar class="mb-2" size="40" color="indigo lighten-5">
                  <v-icon color="yellow darken-3">mdi-mail</v-icon>
                </v-avatar>
                <h6 class="font-weight-bold indigo--text text--darken-4">2. Unggah Surat Balasan</h6>
                <p class="text-caption pb-0">Setelah diverifikasi petugas, Surat pengantar ke perusahaan akan tersedia
                  untuk diunduh dan dikirim ke perusahaan. Tunggu surat balasan dari perusahaan, jika sudah unggah surat
                  balasan diterima atau ditolak kerja praktik diperusahaan, dan tunggu petugas memverifikasi.</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-center">
                <v-avatar class="mb-2" size="40" color="indigo lighten-5">
                  <v-icon color="blue darken-4">mdi-file-upload</v-icon>
                </v-avatar>
                <h6 class="font-weight-bold indigo--text text--darken-4">3. Unggah Berkas Selesai</h6>
                <p class="text-caption pb-0">Unggah Laporan KP, Logbook kegiatan, Lembar konsultasi, Lembar penilaian
                  pembimbing sebagai syarat untuk menyelesaikan kerja praktik</p>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-center">
                <v-avatar class="mb-2" size="40" color="indigo lighten-5">
                  <v-icon color="green">mdi-file-check</v-icon>
                </v-avatar>
                <h6 class="font-weight-bold indigo--text text--darken-4">4. Selesai</h6>
                <p class="text-caption pb-0">Dosen akan memberikan nilai dari kerja praktik yang telah dilakukan.</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    messagesVerification: 0,
    messagesValidation: 0,
  }),
  created() {
    if (this.user)
      this.role = this.user.roles.map(ro => {
        return ro.id;
      })
    if (this.role.includes(2)) this.onOfficerLogin(this.roles);
  },
  methods: {
    onOfficerLogin() {
      this.axios.get("/api/verifikasi/pendaftaran/").then((response) => {
        this.messagesVerification = response.data.data.length;
      });
      this.axios.get("/api/verifikasi/surat-balasan/").then((response) => {
        this.messagesValidation = response.data.data.length;
      });
    },
  }
};
</script>